import { render, staticRenderFns } from "./payment-success2.vue?vue&type=template&id=1dafd10b&scoped=true"
import script from "./payment-success2.vue?vue&type=script&lang=js"
export * from "./payment-success2.vue?vue&type=script&lang=js"
import style0 from "./payment-success2.vue?vue&type=style&index=0&id=1dafd10b&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/payment-success.less?vue&type=style&index=1&id=1dafd10b&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dafd10b",
  null
  
)

export default component.exports